import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, MapPin, Phone, Send } from "lucide-react";
import { FadeUp } from "@/components/motion/Reveal";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return toast.error("Please fill all fields");
    toast.success("Thanks! We'll be in touch shortly.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="pt-[72px] min-h-screen">
      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-24 grid lg:grid-cols-2 gap-16">
        <FadeUp>
          <p className="font-display uppercase tracking-[0.25em] text-primary text-sm font-bold mb-6">
            Get in touch
          </p>
          <h1 className="font-display font-extrabold text-5xl sm:text-6xl tracking-tighter leading-[0.95]">
            Say hello.
          </h1>
          <p className="mt-6 text-lg text-muted-foreground max-w-md leading-relaxed">
            Questions, partnerships, or want to list your shop? Drop us a line and a real human will
            reply.
          </p>
          <div className="mt-10 space-y-4">
            <ContactRow icon={Mail} label="hello@nearbydeals.in" />
            <ContactRow icon={Phone} label="+91 80 4000 1200" />
            <ContactRow icon={MapPin} label="Church Street, Bengaluru" />
          </div>
        </FadeUp>

        <FadeUp delay={0.15}>
          <form onSubmit={submit} className="bg-card rounded-3xl border border-border p-8 space-y-4" data-testid="contact-form">
            <Inp placeholder="Your name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="contact-name" />
            <Inp placeholder="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="contact-email" />
            <textarea
              data-testid="contact-message"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="How can we help?"
              rows={5}
              className="w-full rounded-2xl bg-secondary border border-border px-4 py-3 font-medium focus:outline-none focus:border-primary transition-colors resize-none"
            />
            <button
              type="submit"
              data-testid="contact-submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground font-semibold py-3.5 hover:bg-primary/90 transition-colors"
            >
              <Send className="w-4 h-4" /> Send message
            </button>
          </form>
        </FadeUp>
      </section>
    </div>
  );
}

function ContactRow({ icon: Icon, label }) {
  return (
    <div className="flex items-center gap-3">
      <span className="grid place-items-center w-11 h-11 rounded-2xl bg-secondary text-primary">
        <Icon className="w-5 h-5" />
      </span>
      <span className="font-semibold">{label}</span>
    </div>
  );
}

function Inp({ placeholder, value, onChange, type = "text", testid }) {
  return (
    <input
      data-testid={testid}
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full rounded-2xl bg-secondary border border-border px-4 py-3 font-medium focus:outline-none focus:border-primary transition-colors"
    />
  );
}
